import { GridItem } from '@bnnvara/grids';
import { Heading } from '@bnnvara/typography';
import React from 'react';

const createComposableHeading = (heading) => () => {
  if (!heading) {
    return null;
  }

  return (
    <GridItem columnEndSm="span 12">
      <Heading element="h2" variant="brand">
        {heading}
      </Heading>
    </GridItem>
  );
};

export default createComposableHeading;
